export default {
  text: 'black',
  primary: '#2d8b1a',
  secondary: '#d31e26',
  background: 'white',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
